<template>
  <div
    ref="accordion"
    class="accordion"
    :class="{
      '--open': open,
    }"
  >
    <div class="accordion__header" @click="toggleAccordion">
      <slot name="header"></slot>
      <img
        src="~/assets/img/ico/ico-arrow-down-dark.svg"
        alt="Ico arrow down dark"
        width="13"
        height="15"
        data-animate="accordion-ico"
      />
    </div>
    <div class="accordion__content" data-animate="accordion-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetAccordion',
}
</script>

<script setup>
import { gsap } from 'gsap'

const emit = defineEmits([
  'animation-in-start',
  'animation-start',
  'animation-out-start',
])

const props = defineProps({
  active: Boolean,
})

const accordion = ref(null)
const duration = 0.4

const tl = ref(null)
const open = ref(props.active)

onMounted(() => {
  // Initialize accordion state based on 'active' prop
  tl.value = props.active ? animateIn().duration(0) : animateOut().duration(0)
  tl.value.play()
})

watch(
  () => open.value,
  (open) => {
    if (!tl.value?.isActive()) {
      tl.value = open ? animateIn() : animateOut()
      tl.value.play()
    }
  }
)

const toggleAccordion = () => {
  if (tl.value?.isActive()) {
    tl.value.progress(1)
  }
  open.value = !open.value
}

const animateIn = (params) => {
  const parent = accordion.value
  const ico = parent.querySelector('[data-animate="accordion-ico"]')
  const content = parent.querySelector('[data-animate="accordion-content"]')

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      emit('animation-in-start')
    },
    ...params,
  })

  tl.addLabel('start')
  tl.to(ico, { duration, rotate: '180deg' }, 'start')
  tl.to(content, { duration, height: 'auto', opacity: 1 }, 'start')

  return tl
}

const animateOut = (params) => {
  const parent = accordion.value
  const ico = parent.querySelector('[data-animate="accordion-ico"]')
  const content = parent.querySelector('[data-animate="accordion-content"]')

  const tl = gsap.timeline({
    paused: true,
    onStart: () => {
      emit('animation-out-start')
    },
    ...params,
  })

  tl.addLabel('start')
  tl.to(ico, { duration, rotate: '0deg' }, 'start')
  tl.to(content, { duration, height: 0, opacity: 0 }, 'start')
  return tl
}

defineExpose({
  animateIn,
  animateOut,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
